import Control from "ol/control/Control";
import { MOMA_MIN_ZOOM } from "../layers/MomaTracesLayer";

// Toggle + status for the MoMa traces overlay. Traces auto-load for the current
// viewport (zoom >= MOMA_MIN_ZOOM) while the checkbox is on.
export class MomaTracesControl extends Control {
  constructor(opt_options) {
    const options = opt_options || {};
    const element = document.createElement("div");
    super({
      element: element,
      target: options.target,
    });
    const this_ = this;

    element.className = "moma-traces-control ol-unselectable ol-control";

    const checkbox = document.createElement("input");
    checkbox.type = "checkbox";
    checkbox.id = "moma-traces-input";
    checkbox.checked = false;

    const label = document.createElement("label");
    label.htmlFor = "moma-traces-input";
    label.innerText = "MoMa";
    label.title = `Auto-load MoMa session traces for the viewport (zoom ≥ ${MOMA_MIN_ZOOM})`;

    const status = document.createElement("span");
    status.style.cssText = "margin-left:6px; font-size:11px; color:#555;";

    const sessions = document.createElement("div");
    sessions.style.cssText =
      "font-size:11px; max-width:220px; overflow-wrap:anywhere; color:#333;";

    checkbox.addEventListener("change", function () {
      this_.set("momaToggle", checkbox.checked);
    });
    this_.set("momaToggle", checkbox.checked);

    this.restoreState = function (momaToggle) {
      if (momaToggle && !checkbox.disabled) {
        checkbox.checked = true;
        this_.set("momaToggle", true);
      }
    };

    this.setDisabled = function (disabled) {
      checkbox.disabled = disabled;
      label.style.color = disabled ? "grey" : "black";
    };

    this.on("propertychange", function (e) {
      if (e.key === "zoom") {
        const active = e.target.get("zoom") >= MOMA_MIN_ZOOM;
        label.style.color = active ? "black" : "grey";
      }
      if (e.key === "momaStatus") {
        status.innerText = this_.get("momaStatus") || "";
      }
      if (e.key === "selectedSessions") {
        const names = this_.get("selectedSessions") || [];
        sessions.innerText = names.join("\n");
      }
    });

    element.appendChild(checkbox);
    element.appendChild(label);
    element.appendChild(status);
    element.appendChild(sessions);
  }
}
